<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import { button } from '$components/ui/button.svelte';
  import { t } from '$lib/i18n';
  import { reducedMotion } from '$lib/stores/reduced-motion';
  import { cn } from '$lib/utils';
  import { getType } from '$lib/utils/file';
  import type { ImageVideoStoryblok } from '$types/bloks';
  import { fade } from 'svelte/transition';
  export let block: ImageVideoStoryblok;

  let video: HTMLVideoElement;
  let isVideoPlaying = false;
  const extension = block.asset.filename.split('.').pop() || '';
  const type = getType(extension);
</script>

{#if type && block.asset}
  <section class="px-2 py-12 lg:px-8 lg:py-16 w-full">
    <div class={cn('container mx-auto', type === 'video' && 'w-fit')}>
      {#if type === 'image'}
        <CmsImage
          image={block.asset}
          class="relative z-10 rounded-md object-cover w-full max-h-[90vh]"
        />
      {/if}
      {#if type === 'video'}
        <div class="relative z-10 rounded-md overflow-hidden">
          <button
            aria-label={isVideoPlaying ? 'Pause video' : 'Play video'}
            on:click={() => (isVideoPlaying ? video?.pause() : video?.play())}
            class="w-full after:absolute after:top-full after:pointer-events-none after:bg-background after:left-0 after:right-0 after:h-full"
          >
            <video
              bind:this={video}
              on:pause={() => (isVideoPlaying = false)}
              on:play={() => (isVideoPlaying = true)}
              on:ended={() => video.load()}
              autoplay={!!block.autoplay}
              loop={!!block.loop}
              muted={!!block.mute}
              preload="metadata"
              src={block.thumbnail?.filename
                ? block.asset.filename
                : block.asset.filename + '#t=0.001'}
              class="w-full rounded-md block max-h-[90vh]"
              poster={block.thumbnail?.filename}
            />
            {#if !video || !isVideoPlaying}
              <div
                class={cn(
                  button({ variant: 'secondary', size: 'md' }),
                  'absolute z-10 bottom-4 left-4 backdrop-blur right-4 lg:right-[unset]'
                )}
                transition:fade={{ duration: $reducedMotion ? 0 : 150 }}
              >
                {$t('hero.watch-video')}
              </div>
            {/if}
          </button>
        </div>
      {/if}
    </div>
  </section>
{/if}

<style>
  video[poster] {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
</style>
